import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormHelperText from "@mui/material/FormHelperText";

function SearchableSelectInput(props) {
  const handleAutocompleteChange = (event, newValue) => {
    // Save only the label of the selected option
    if (typeof newValue === "string") {
      // If the user types a custom value
      props.handleChange({ target: { name: props.name, value: newValue } });
    } else if (newValue && newValue.value) {
      // If the user selects from the dropdown
      props.handleChange({ target: { name: props.name, value: newValue.value } });
    } else {
      props.handleChange({ target: { name: props.name, value: "" } });
    }
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <Autocomplete
        disablePortal
        freeSolo
        options={props.options}
        getOptionLabel={(option) => typeof option === "string" ? option : option.label}
        value={props.value || ""} // Set to empty string if no value
        onChange={handleAutocompleteChange} // Handle value change
        isOptionEqualToValue={(option, value) => option.label === value} // Compare by label
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            placeholder={props.placeholder}
            variant="outlined"
            error={props.error}
          />
        )}
      />
      {props.error && <FormHelperText>{props.helperText}</FormHelperText>}
    </Box>
  );
}

SearchableSelectInput.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired, // Array of { label, value } objects
  value: PropTypes.string, // Now only storing the label as a string
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
};

export default SearchableSelectInput;
